<template>
  <center>
    <div class="card card-body agatrs-card-style">
      <Header pageTitle="FAQs" class="card-container"></Header>

      <div class="row no-bottom-margin">
        <div class="col-md-3 my-auto">
          <base-button :class="'btn_info'" @click.native="addVisible = true">
            <i class="tim-icons icon-simple-add"></i>Add Item
          </base-button>
        </div>
        <!-- Show Search Page "Search Order" Styling -->
        <div class="col-md-3 offset-md-6">
          <label for="searchBox">Search:</label>
          <el-input id="searchBox" type="search" class="mb-3 search-input" clearable prefix-icon="el-icon-search"
            placeholder="Search all FAQs..." @input="getPaginateFaqs()" v-model="searchQuery" v-b-popover.hover.top="'Search results appear immediately upon typing.'
              "></el-input>
        </div>
      </div>

      <div class="card border border-secondary rounded border-2" v-if="addVisible">
        <div class="card-body">
          <div class="row d-flex align-items-start pb-3">
            <div class="col-md-6 my-2">
              <label for="question" class="d-flex align-items-start">Question</label>
              <el-input type="textarea" :rows="3" placeholder="Please type the question" name="question"
                v-model="add.question">
              </el-input>
            </div>
            <div class="col-md-6 my-2">
              <label for="answer" class="d-flex align-items-start">Answer</label>
              <el-input type="textarea" :rows="3" placeholder="Please type the answer" name="answer" v-model="add.answer">
              </el-input>
            </div>
          </div>

          <div class="row d-flex align-items-end">
            <div class="col-md-12 my-2">
              <base-button class="btn btn-fab btn-danger" @click.native="() => {
                addVisible = false;
                add = { id: 0, question: '', answer: '' };
              }
                ">
                <i class="tim-icons icon-simple-remove"></i>Cancel
              </base-button>
              <base-button class="btn btn-fab btn-success" @click.native="save(add)">
                <i class="tim-icons icon-check-2"></i>Save
              </base-button>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <card class="card-plain" body-classes="table-full-width">
          <el-table ref="table" :data="faqs.results" :default-sort="{ prop: 'question', order: 'descending' }">
            <el-table-column :min-width="140" align="left" label="Actions">
              <div slot-scope="{ row }" class="table-actions">
                <template v-if="editRowId === row.id">
                  <el-tooltip content="Cancel Request" :open-delay="300" effect="light" placement="top">
                    <base-button class="btn btn-fab btn-danger" @click.native="cancel()">
                      <i class="tim-icons icon-simple-remove"></i>Cancel
                    </base-button>
                  </el-tooltip>
                  <el-tooltip content="Save Changes" :open-delay="300" effect="light" placement="top">
                    <base-button class="btn btn-fab btn-success" @click.native="save(row)">
                      <i class="tim-icons icon-check-2"></i>Save
                    </base-button>
                  </el-tooltip>
                </template>
                <template v-else-if="removeRowId === row.id">
                  <el-tooltip content="Cancel Request" :open-delay="300" effect="light" placement="top">
                    <base-button class="btn btn-fab btn-danger" @click.native="removeRowId = -1">
                      <i class="tim-icons icon-simple-remove"></i>Cancel
                    </base-button>
                  </el-tooltip>
                  <el-tooltip content="Confirm Delete" :open-delay="300" effect="light" placement="top">
                    <base-button class="btn btn-fab btn-success" @click.native="remove(row.id)">
                      <i class="tim-icons icon-check-2"></i>Confirm
                    </base-button>
                  </el-tooltip>
                </template>
                <template v-else>
                  <el-tooltip content="Remove FAQ Item" :open-delay="300" effect="light" placement="top">
                    <base-button class="btn btn-fab btn-danger" @click.prevent="removeRowId = row.id">
                      <i class="tim-icons icon-trash-simple"></i>Remove
                    </base-button>
                  </el-tooltip>

                  <el-tooltip content="Edit FAQ Item" :open-delay="300" effect="light" placement="top">
                    <base-button class="btn btn-fab btn-default" @click.native="editRowId = row.id">
                      <i class="tim-icons icon-pencil"></i>Edit
                    </base-button>
                  </el-tooltip>
                </template>
              </div>
            </el-table-column>

            <el-table-column label="Question" property="question" min-width="180">
              <template slot-scope="{ row }">
                <editable-cell :show-input="editRowId === row.id" type="textarea" :rows="3" v-model="row.question">
                  <span slot="content">{{ row.question }}</span>
                </editable-cell>
              </template>
            </el-table-column>

            <el-table-column label="Answer" property="answer" min-width="280">
              <template slot-scope="{ row }">
                <editable-cell :show-input="editRowId === row.id" type="textarea" :rows="3" v-model="row.answer">
                  <span slot="content">{{ row.answer }}</span>
                </editable-cell>
              </template>
            </el-table-column>
          </el-table>
          <div slot="footer" class="
              col-12
              d-flex
              justify-content-center justify-content-sm-between
              flex-wrap
            ">
            <el-select class="select-primary mb-3 pagination-select" v-model="pageCount" @change="getPaginateFaqs()"
              readonly="false" name="PageOptions" placeholder="Per page">
              <el-option v-for="(item, index) in pageCountOptions" :value="item" class="select-primary"
                :key="index"></el-option>
            </el-select>

            <base-pagination v-model="faqs.currentPage" @input="getPaginateFaqs()" :perPage="faqs.pageSize"
              :pageCount="faqs.pageCount">
            </base-pagination>
          </div>
        </card>
      </div>
    </div>
  </center>
</template>

<script>
import Header from "@/components/App/Header.vue";
import { Table, TableColumn, Select, Option } from "element-ui";
import { mapGetters, mapActions } from "vuex";
import { BasePagination, BaseButton, EditableCell } from "@/components";
export default {
  name: "SuperUserFaqs",
  components: {
    Header,
    BaseButton,
    BasePagination,
    EditableCell,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },
  data: function () {
    return {
      searchQuery: "",
      editRowId: -1,
      removeRowId: -1,
      pageCount: 5,
      pageCountOptions: [5, 10, 20, 50, 100],
      add: {
        id: 0,
        question: "",
        answer: "",
      },
      addVisible: false,
    };
  },
  computed: {
    ...mapGetters({ faqs: "faq/faqs" }),
  },

  watch: {},
  async created() {
    this.getPaginateFaqs();
  },
  methods: {
    ...mapActions({
      getFaqs: "faq/getFaqsPaginate",
      saveFaq: "faq/saveFaq",
      removeFaq: "faq/removeFaq",
    }),
    async cancel() {
      this.getPaginateFaqs();
      this.editRowId = -1;
    },

    async save(data) {
      let ctx = this;
      this.editRowId = -1;
      this.addVisible = false;
      await this.saveFaq(data).then(() => ctx.getPaginateFaqs());
      this.add = { id: 0, question: "", answer: "" };
    },

    async remove(id) {
      let ctx = this;
      this.removeRowId = -1;
      await this.removeFaq(id).then(() => ctx.getPaginateFaqs());
    },

    async getPaginateFaqs() {
      let ctx = this;
      return await ctx.getFaqs({
        pageNumber: ctx.faqs.currentPage ? ctx.faqs.currentPage : 1,
        pageCount: ctx.pageCount,
        searchText: ctx.searchQuery ? ctx.searchQuery : "",
      });
    },
  },
};
</script>

<style scoped></style>
